<template>
  <a href="/parser/iof_runners" class="btn btn-primary">WRE Ranking</a>
  <br>
  <br>
  <a href="/parser/iof_results" class="btn btn-primary">WRE Rezultate</a>
</template>
